import { defineComponent as _defineComponent } from 'vue'
import 
TUIChatEngine,
{
  TUITranslateService,
  TUIUserService,
  TUIConversationService,
  TUIGlobal,
  TUIFriendService,
} from "@tencentcloud/chat-uikit-engine";
import {
  defineProps,
  ref,
  watch,
  defineEmits,
  watchEffect,
} from "../../../adapter-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-profile',
  props: {
  userInfo: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["handleSwitchConversation", "toggleEdit", "openConversation"],
  setup(__props, { emit: emits }) {

const props = __props



const isFriendShip = ref(false);
const userInfoManage = ref({});
const self = ref({});
const isUniFrameWork = ref(typeof uni !== 'undefined');

watchEffect(() => {
  userInfoManage.value = props.userInfo;
});


watch(
  () => props.userInfo,
  async (newVal: any, oldVal: any) => {
    if (newVal === oldVal) return;
    const res = await TUIUserService.getUserProfile({
      userIDList: [props.userInfo.userID],
    });
    userInfoManage.value = res?.data[0];
    // 这里需要确认是否是好友关系
    checkFriend();
  },
  {
    deep: true,
    immediate: true,
  }
);

const enter = async (ID: any, type: string) => {
  const name = `${type}${ID}`;
  TUIConversationService.getConversationProfile(name)
    .then((res: any) => {
      TUIConversationService.switchConversation(
        res.data.conversation.conversationID
      );
      if(isUniFrameWork.value) {
        emits("openConversation");
      } else {
        emits("handleSwitchConversation", res.data.conversation.conversationID);
      }
    })
    .catch((err: any) => {
      console.warn("获取会话资料失败", err.code, err.msg);
    });
};
const checkFriend = async () => {
  if (!(userInfoManage.value as any).userID) return;
  // 这里暂时屏蔽
  // const relation = await TUIFriendService.checkFriend(userInfo.value.userID, TUIChatEngine.TYPES.SNS_CHECK_TYPE_BOTH);
  // isFriendShip.value = (relation === TUIChatEngine.TYPES.SNS_TYPE_BOTH_WAY) ? true : false;
  if(!isUniFrameWork.value) {
    isFriendShip.value = true;
  }
};

const showEnter = () => {
  return isFriendShip.value || !TUIGlobal.isOfficial;
};

const toggleEdit = async (tabName: string) => {
  emits("toggleEdit", tabName);
};

return { __sfc: true,props, isFriendShip, userInfoManage, self, isUniFrameWork, emits, enter, checkFriend, showEnter, toggleEdit, TUITranslateService }
}

})